import {
  ColorDecorativeBlue50,
  ColorDecorativeBlue70,
  ColorDecorativeBlue90,
  ColorDecorativeGreen50,
  ColorDecorativeGreen70,
  ColorDecorativeGreen90,
  ColorDecorativePink70,
  ColorDecorativePink90,
  ColorDecorativePurple50,
  ColorDecorativePurple70,
  ColorDecorativePurple90,
  ColorDecorativeYellow50,
  ColorDecorativeYellow70,
  ColorDecorativeYellow90,
} from '@snowball-tech/design-tokens'

import { Apps } from './enums'

// Also remember to update the locales defined in the next.config.mjs file (of
// this "common" package) so that your redirections also works in all supported
// locales.
export const LOCALES = ['fr', 'en'] as const
export const DEFAULT_LOCALE = 'fr'
export const DEFAULT_TIMEZONE = 'Europe/Paris'

export const SNOWBALL_DOMAIN =
  process.env.SNOWBALL_DOMAIN ||
  process.env.NEXT_PUBLIC_SNOWBALL_DOMAIN ||
  'snowball.xyz'
export const SNOWBALL_MEDIA_DOMAIN =
  process.env.SNOWBALL_MEDIA_DOMAIN ||
  process.env.NEXT_PUBLIC_SNOWBALL_MEDIA_DOMAIN ||
  'media-snowball.com'

export const PREPROD_DOMAIN = `preprod.${SNOWBALL_DOMAIN}`
export const LOCAL_DOMAIN = `local-${SNOWBALL_DOMAIN}`

export const SNOWBALL_MAX_WHATSAPP_NUMBER = '33756856232'
/** @public */
export const SNOWBALL_MAX_WHATSAPP_LINK = `https://wa.me/${SNOWBALL_MAX_WHATSAPP_NUMBER}`

export const HELP_CENTER_URL = `https://support.${SNOWBALL_DOMAIN}/fr/`
export const FOOTER_TOOLS_URL = 'https://shopsnowball.gumroad.com/'
export const CONTACT_EMAIL =
  '%79%6F%61%6E%6E%40%73%6E%6F%77%62%61%6C%6C%2E%78%79%7A'
export const HEY_EMAIL = '%68%65%79%40%73%6E%6F%77%62%61%6C%6C%2E%78%79%7A'
export const BTC_URL = 'https://behindthecurtain.substack.com/'
export const DISCORD_URL = 'https://discord.gg/xVkNq7vZHX'
export const INSTAGRAM_URL = 'https://www.instagram.com/snowball.xyz/'
export const LEGAL_NOTICE_DOC_URL =
  'https://docs.google.com/document/d/1H7y-49KIM0zmwxdyTY8QzaQO3uyNFzFdKI9zkoc-PyU/edit'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/getsnowball/'
export const PERKS_URL =
  'https://www.notion.so/swbl/25d0021b72054a18a61a915d25b8a750?v=ed13146d857e42f89a0327499feae834'
export const SNOWBALL_BOOK_URL =
  'https://www.amazon.fr/Leffet-snowball-comment-investir-intelligence/dp/241600431X'
export const SNOWBALL_JOB_CENTER =
  'https://swbl.notion.site/Snowball-Job-Center-3aee66fdbfcb428bacd2f4a0c98e0145'
export const STRIPE_URL =
  'https://billing.stripe.com/p/login/8wM5mya3ibaUcSseUU'
export const ACCOUNT_DELETION_URL = 'https://tally.so/r/wA6L9N'
export const TRUSTPILOT_URL = 'https://fr.trustpilot.com/review/snowball.xyz'
export const X_URL = 'https://x.com/snowball'
/** @public */
export const TOOLS_URL = {
  financeSpreadsheet:
    'https://docs.google.com/spreadsheets/u/1/d/1yRpTj2StCnAgOCejpsTz-JMqGlzrOM4l/copy',
  investTracker:
    'https://docs.google.com/spreadsheets/u/1/d/1CHFyamB7fak5Tnq775QChDrv8FfaZFpmZ0DvYhgq7fY/copy',
}

/** @public */
export const USER_HOME_URL = '/home'
/** @public */
export const USER_PROFILE_URL = `${USER_HOME_URL}/profile`
export const SIGNIN_URL = '/signin'
export const SIGNOUT_URL = '/signout'
export const BASE_DEFAULT_PUBLIC_PAGES = ['', '/', SIGNIN_URL, SIGNOUT_URL]
export const DEFAULT_PUBLIC_PAGES = BASE_DEFAULT_PUBLIC_PAGES.filter(Boolean)
LOCALES.forEach((locale) => {
  DEFAULT_PUBLIC_PAGES.push(
    ...BASE_DEFAULT_PUBLIC_PAGES.map((pathname) => `/${locale}${pathname}`),
  )
})
DEFAULT_PUBLIC_PAGES.push(
  ...BASE_DEFAULT_PUBLIC_PAGES.map((pathname) => `/:locale${pathname}`),
)

export const COLORS = ['yellow', 'green', 'blue', 'purple', 'pink'] as const
export const NEED_DARKER_PLACEHOLDER_COLORS = [
  'light-pink',
  'purple',
  'yellow',
  'green',
]
export const TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justify'] as const

export const CONFETTI_COLORS = [
  ColorDecorativeBlue50,
  ColorDecorativeBlue70,
  ColorDecorativeBlue90,
  ColorDecorativeGreen50,
  ColorDecorativeGreen70,
  ColorDecorativeGreen90,
  ColorDecorativePink70,
  ColorDecorativePink90,
  ColorDecorativePurple50,
  ColorDecorativePurple70,
  ColorDecorativePurple90,
  ColorDecorativeYellow50,
  ColorDecorativeYellow70,
  ColorDecorativeYellow90,
]
export const DEFAULT_CONFETTI_DURATION = 3000

export const MAIN_ANALYTICS_DASHBOARD_URL = `https://snowball.grafana.net/d/aecf5j3qkadq8a/analytics?orgId=1&from=now-5m&to=now&timezone=browser&var-Source=$__SOURCE__&var-Source=$__ANALYTICS_SOURCE__`

export const ANALYTICS_DASHBOARD_URL = `https://snowball.grafana.net/d/ddwyzptxqu4g0f/article-analytics?orgId=1&from=now-5m&to=now&timezone=browser&var-Source=$__SOURCE__&var-Analytics=$__ANALYTICS_SOURCE__&var-Edition=$__EDITION__`

export const GRAFANA_SOURCE_IDS = {
  preprod: 'b4a29876-269f-48ef-8bab-0e0537d283fe',
  prod: 'efa31268-59bb-402b-b5b3-cff3212428a3',
}
export const GRAFANA_ANALYTICS_SOURCE_IDS = {
  preprod: 'aec5milh6nqiof',
  prod: 'fec27ldey0nb4a',
}

export const NEWSLETTERS_ORDER = [
  'daily',
  'learn',
  'report',
  'igloo',
  'crypto',
  'bourse',
  'la-bonne-paye',
  'makers',
  'toujours-pas-en-france',
  'couple',
  'therapie',
  'grand-cru',
  'lego',
  'snowball',
]

export const DEFAULT_APP_NAME = Apps.Media
export const WHATSAPP_DAILY_SLUG =
  process.env.WHATSAPP_DAILY_SLUG ||
  process.env.NEXT_PUBLIC_WHATSAPP_DAILY_SLUG ||
  'recevoir-le-daily-snow-sur-whatsapp'
export const PREVIEW_TEXT_PADDING = '͏ &nbsp;   ­͏'

export const MAGIC_LINK_RESEND_DELAY = 15_000
export const MAX_USER_LOAD_RETRIES_NUMBER = 4
export const MAX_UPLOAD_SIZE = 1024 * 1024 * 2
export const MAX_DIRECT_UPLOAD_SIZE = 1024 * 1024 * 1024 * 1
export const MEDIA_MEDIAS_BUCKET =
  process.env.SUPABASE_MEDIAS_BUCKET_NAME ||
  process.env.NEXT_PUBLIC_SUPABASE_MEDIAS_BUCKET_NAME ||
  'media_medias'

export const SNOWBALL_GTM_ID =
  process.env.GTM_ID || process.env.NEXT_PUBLIC_GTM_ID
export const SNOWBALL_GOOGLE_ANALYTICS_ID =
  process.env.GOOGLE_ANALYTICS_ID || process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID
export const CRAZY_EGG_ACCOUNT_NUMBER =
  process.env.CRAZY_EGG_ACCOUNT_NUMBER ||
  process.env.NEXT_PUBLIC_CRAZY_EGG_ACCOUNT_NUMBER
